<script>
import axios from '@/utils/axios';
import units from "@/assets/json/units.json";

export default {
inject: ['setLoading'],    
 data() {
  return { 
    units: units,
   title: "CRM",
   text: "CRM",
   app_currency: '',
   data: [],
   status: '',
   inventory_type: '',
   item_group_id: '',     
   item_groups: [],
   search: '',
   pagination: {
    current_page: 1,
    per_page: 25,
    last_page: 1,
    total: 0,
    links: []
   },
  };
},

computed: {
  text1(){
   return `Items (${this.pagination.total})`; 
  },
  serialNo(){
   return (this.pagination.current_page - 1) * this.pagination.per_page; 
  }
},

async mounted() {
 this.items();
 this.getItemGroups();  
 this.app_currency = await this.$appCurrency();
}, 

methods: {

async getItemGroups() {
  try {
    const res = await axios.get('/item-groups');
    this.item_groups = res.data.data || [];
  } catch (error) {
    this.$swalToast(error.message, 'error');
  }
},

 async items(page = 1){
  this.setLoading(true);
   try{
    const params = {
     page,
     status: this.status,
      inventory_type: this.inventory_type,
      item_group_id: this.item_group_id,
     search: this.search.trim() || '' 
    };
    const query_string = new URLSearchParams(params).toString();
    const response = await axios.get(`/items?${query_string}`);
    this.data = response.data.data.data;
    this.pagination = {
     current_page: response.data.data.current_page,
     per_page: response.data.data.per_page,
     last_page: response.data.data.last_page,
     total: response.data.data.total,
     links: response.data.data.links 
    };
   }catch(error){
    this.$swalToast(error.message, 'error');
   }finally{
    this.setLoading(false);
   }
 },

 changePage(url){
  if(!url) return;
  const page = new URL(url).searchParams.get("page");
  this.items(page);
 },

 async exportFile(format){
  this.setLoading(true);
  try{
    const response = await axios.get(`/items/export/${format}`, {
     responseType: 'blob',
    });

    const blob = new Blob([response.data], {
     type: response.headers['content-type'],
    });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);

    let filename = `items_export_${this.$timeStamp()}.${format}`;
    const disposition = response.headers['content-disposition'];

    if(disposition && disposition.indexOf('filename=') !== -1){
     const filenameMatch = disposition.match(/filename="?(.+)"?/);
     if(filenameMatch && filenameMatch.length === 2){
      filename = filenameMatch[1];
     }
    }

    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
  }catch(error){
   console.error(error);
   this.$swalToast(error?.message || 'Export failed', 'error');
  }finally{
   this.setLoading(false);
  }
 },

 async updateStatus(row){
  try{
   const status = row.status ? 1 : 0; 
   await axios.patch(`/items/${row.id}/status/${status}`);
  }catch(error){
   row.status = !row.status; 
   this.$swalToast(error.message, 'error');
  }
 },

 clearFilter(){
  this.status = '';
  this.inventory_type = '';
  this.item_group_id = '';
  this.search = '';
  this.items(1); 
 }

 },
};
</script>


<style scoped>
/* ── FILTER BAR ── */
.i-filter-select {
  height: 36px; border: 1.5px solid #e2e8f0; border-radius: 8px;
  padding: 0 10px; font-size: 12.5px; color: #1e293b;
  background: #fff; outline: none; cursor: pointer;
  transition: border-color .15s; min-width: 120px;
}
.i-filter-select:focus { border-color: #6366f1; box-shadow: 0 0 0 3px rgba(99,102,241,.1); }
 
.i-search-wrap {
  display: flex; align-items: center;
  border: 1.5px solid #e2e8f0; border-radius: 8px;
  overflow: hidden; background: #fff;
  transition: border-color .15s;
}
.i-search-wrap:focus-within { border-color: #6366f1; box-shadow: 0 0 0 3px rgba(99,102,241,.1); }
.i-search-input {
  border: none; outline: none; height: 34px;
  padding: 0 10px; font-size: 12.5px; color: #1e293b;
  width: 190px; background: transparent;
}
.i-search-btn {
  width: 36px; height: 36px; background: #0f172a;
  border: none; color: #fff; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  font-size: 14px; transition: background .15s;
}
.i-search-btn:hover { background: #1e293b; }
 
.i-clear-btn {
  width: 34px; height: 34px; background: #fff0f3;
  border: 1.5px solid #fecdd3; border-radius: 8px;
  color: #f43f5e; font-size: 15px; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  transition: all .15s;
}
.i-clear-btn:hover { background: #f43f5e; color: #fff; border-color: #f43f5e; }
 
/* ── ITEM IMAGE ── */
.i-thumb {
  width: 40px; height: 40px; border-radius: 8px;
  object-fit: cover; border: 1px solid #e2e8f0;
}
 
/* ── ITEM NAME ── */
.i-name { font-size: 13px; font-weight: 600; color: #0f172a; }
.i-code-badge {
  display: inline-block; font-size: 10px; color: #6366f1;
  background: #eef2ff; border: 1px solid #c7d2fe;
  border-radius: 20px; padding: 1px 8px; margin-top: 3px;
  cursor: pointer;
}
 
/* ── PRICE ── */
.i-price { font-size: 13px; font-weight: 600; color: #16a34a; }
 
/* ── GROUP PATH ── */
.i-group { font-size: 12px; color: #64748b; }
 
/* ── TAX BADGE ── */
.i-tax-badge {
  font-size: 10.5px; color: #92400e;
  background: #fef3c7; border: 1px solid #fde68a;
  border-radius: 20px; padding: 2px 8px;
  display: inline-block; font-weight: 500;
}
</style>
 
<template>
<layout-header></layout-header>
<layout-sidebar></layout-sidebar>
 
<div class="page-wrapper">
<div class="content">
 
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <breadcrumb :title="title" :text="text" :text1="text1" />
    <div class="d-flex my-xl-auto right-content align-items-center flex-wrap gap-2">

      <!-- Available Units -->
      <a href="javascript:void(0);"
        data-bs-toggle="modal" data-bs-target="#units_modal"
        class="btn btn-white d-flex align-items-center" style="border: 1px solid #E5E7EB;">
        <i class="ti ti-ruler-measure me-2"></i>Available Units
      </a>
 
      <!-- Import -->
      <div v-if="auth.type === 'ADMIN'">
        <div class="dropdown">
          <a href="javascript:void(0);" class="dropdown-toggle btn btn-white d-inline-flex align-items-center" data-bs-toggle="dropdown">
            <i class="ti ti-file-import me-1"></i>Import
          </a>
          <ul class="dropdown-menu dropdown-menu-end p-3">
            <li>
              <router-link to="/crm/items/import/csv" class="dropdown-item rounded-1">
                <i class="ti ti-file-type-csv me-1"></i>Import from CSV
              </router-link>
            </li>
          </ul>
        </div>
      </div>
 
      <!-- Export -->
      <div v-if="data?.length">
        <div class="dropdown">
          <a href="javascript:void(0);" class="dropdown-toggle btn btn-white d-inline-flex align-items-center" data-bs-toggle="dropdown">
            <i class="ti ti-file-export me-1"></i>Export
          </a>
          <ul class="dropdown-menu dropdown-menu-end p-3">
            <li>
              <a href="javascript:void(0);" class="dropdown-item rounded-1" @click="exportFile('csv')">
                <i class="ti ti-file-type-csv me-1"></i>Export as CSV
              </a>
            </li>
            <li>
              <a href="javascript:void(0);" class="dropdown-item rounded-1" @click="exportFile('xlsx')">
                <i class="ti ti-file-type-xls me-1"></i>Export as Excel
              </a>
            </li>
          </ul>
        </div>
      </div>
 
      <!-- Add Item -->
      <a href="javascript:void(0);"
        data-bs-toggle="modal" data-bs-target="#item_modal"
        class="btn btn-primary d-flex align-items-center"
        @click="$refs.itemModal.add();">
        <i class="ti ti-circle-plus me-2"></i>Add Item
      </a>
 
    </div>
  </div>
  <!-- /Breadcrumb -->
 
  <!-- Main Card -->
  <div class="card border-0 shadow-sm mb-0" style="border-radius:14px; overflow:hidden;">
 
    <!-- Card Header -->
    <div class="card-header bg-white border-bottom d-flex align-items-center justify-content-between flex-wrap gap-3 py-3 px-4">
      <h5 class="mb-0 fw-bold" style="font-size:14px; color:#0f172a;">
        Items List
        <span style="font-size:11px; color:#94a3b8; font-weight:500; margin-left:6px;">({{ pagination.total }})</span>
      </h5>
 
      <!-- Filters -->
      <div class="d-flex align-items-center flex-wrap gap-2">
 
        <!-- Clear -->
        <button v-if="search || status || inventory_type || item_group_id" class="i-clear-btn" @click="clearFilter()" title="Clear filters">
          <i class="ti ti-filter-x"></i>
        </button>
 
        <!-- Status -->
        <vue-select
        v-model="status"
        :options="[
          { label: 'Active', value: 'active' },
          { label: 'Inactive', value: 'inactive' },
        ]"
        label="label"
        :reduce="s => s.value"
        placeholder="Status"
        :clearable="true"
        @update:modelValue="items(1)"
        style="min-width: 140px;"
      ></vue-select>

      <!-- Inventory Type -->
      <vue-select
        v-model="inventory_type"
        :options="[
          { label: 'Finish', value: 'finish' },
          { label: 'Raw', value: 'raw' },
        ]"
        label="label"
        :reduce="s => s.value"
        placeholder="Inv. Type"
        :clearable="true"
        @update:modelValue="items(1)"
        style="min-width: 140px;"
      ></vue-select>

      <!-- Category -->
      <vue-select
        v-model="item_group_id"
        :options="item_groups"
        label="name"
        :reduce="g => g.id"
        placeholder="Category"
        :clearable="true"
        @update:modelValue="items(1)"
        style="min-width: 160px;"
      ></vue-select>
 
        <!-- Search + Button -->
        <div class="i-search-wrap">
          <input type="text" class="i-search-input" v-model="search" placeholder="Search items..." />
          <button class="i-search-btn" type="button" @click="items(1)">
            <i class="ti ti-search"></i>
          </button>
        </div>
 
      </div>
    </div>
 
    <!-- Card Body — Table -->
    <div class="card-body card-table-wrapper">
 
      <div class="table-responsive" v-if="data?.length">
        <table class="card-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Image</th>
              <th>Price</th>
              <th>Group</th>
              <th>Tax</th>
              <th>Inv. Type</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in data" :key="row.id">
 
              <!-- Serial -->
              <td style="color:#94a3b8; font-size:11px; font-weight:600; width:42px;">
                {{ serialNo + index + 1 }}.
              </td>
 
              <!-- Name + Code -->
              <td>
                <div class="i-name">{{ row.name }}</div>
                <div>
                  <a class="i-code-badge" @click="$copyText(row?.code)">
                    {{ row?.code }}
                  </a>
                </div>
              </td>
 
              <!-- Image -->
              <td>
                <img v-if="row.image" :src="row.image_url" class="i-thumb" />
                <i v-else class="ti ti-photo fs-24 text-muted"></i>
              </td>
 
              <!-- Price -->
              <td>
                <span class="i-price">{{ app_currency.symbol }}{{ row.price }}</span>
              </td>
 
              <!-- Group -->
              <td>
                <span class="i-group">{{ row?.leaf_path }}</span>
              </td>
 
              <!-- Tax -->
              <td>
                <span v-if="row.tax?.name" class="i-tax-badge">{{ row.tax?.name }}</span>
                <span v-else style="color:#cbd5e1;">—</span>
              </td>

              <!-- Inventory Type -->
              <td>
                <span v-if="row.inventory_type" class="i-inv-badge" :class="row.inventory_type">
                  {{ row.inventory_type }}
                </span>
                <span v-else style="color:#cbd5e1;">—</span>
              </td>
 
              <!-- Status -->
              <td>
                <div class="form-check form-switch mb-0">
                  <input class="form-check-input" type="checkbox" v-model="row.status" @change="updateStatus(row)" />
                </div>
              </td>
 
              <!-- Actions -->
              <td>
                <div class="dropdown">
                  <button class="btn btn-icon btn-sm rounded-circle" type="button"
                    data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="ti ti-dots-vertical"></i>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <a class="dropdown-item rounded-1" href="javascript:void(0);"
                        data-bs-toggle="modal" data-bs-target="#item_modal"
                        @click="$refs.itemModal.editItem(row)">
                        <i class="ti ti-edit me-1"></i>Edit
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item rounded-1" href="javascript:void(0);"
                        data-bs-toggle="modal" data-bs-target="#item_delete_modal"
                        @click="$refs.itemModal.editItem(row)">
                        <i class="ti ti-trash me-1"></i>Delete
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
 
            </tr>
          </tbody>
        </table>
      </div>
 
      <!-- Empty State -->
      <div v-else style="text-align:center; padding:48px; color:#94a3b8;">
        <i class="ti ti-box" style="font-size:36px; display:block; margin-bottom:10px; opacity:.35;"></i>
        No records found.
      </div>
 
      <!-- Pagination -->
      <nav v-if="pagination.links.length > 3" class="px-2 py-3">
        <ul class="card-pagination">
          <li v-for="(link, index) in pagination.links" :key="index"
            :class="{ active: link.active, disabled: !link.url }">
            <a href="javascript:void(0)" v-html="link.label" @click="changePage(link.url)"></a>
          </li>
        </ul>
      </nav>
 
    </div>
  </div>
  <!-- /Main Card -->
 
</div>
 
<app-footer></app-footer>
</div>
 
<item-modal ref="itemModal" @updated="items"></item-modal>

<!-- Units Modal -->
<div class="modal fade" id="units_modal">
  <div class="modal-dialog modal-dialog-centered modal-sm">
    <div class="modal-content" style="border:none; border-radius:12px; box-shadow:0 8px 40px rgba(0,0,0,0.13);">
      <div class="modal-header" style="border-bottom:1px solid #f0f0f0; padding:14px 20px;">
        <h5 class="modal-title mb-0 fw-semibold" style="font-size:14px;">Available Units</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body" style="max-height:50vh; overflow-y:auto; padding:12px 16px;">
        <div class="d-flex flex-wrap gap-2">
          <span v-for="(unit, index) in units" :key="index"
            class="unit-chip"
            @click="$copyText(unit)"
            title="Click to copy">
            {{ unit }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>

</template>

<style scoped>
/* ── INVENTORY TYPE BADGE ── */
.i-inv-badge {
  font-size: 10.5px; padding: 2px 8px;
  border-radius: 20px; display: inline-block; font-weight: 500;
}
.i-inv-badge.finish {
  background: #dcfce7; color: #16a34a; border: 1px solid #bbf7d0;
}
.i-inv-badge.raw {
  background: #fef3c7; color: #92400e; border: 1px solid #fde68a;
}

</style>